'use client'

import { useI18n } from '@dustin-web/microsite-components/src/i18n'
import AddToCartButton from '@dustin-web/product-components/src/add-to-cart-button'
import { AddNote } from '@dustin-web/product-components/src/add-note-to-cart-item'
import { CartItemFragment } from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'
import { DigitalDataOrigin } from '@dustin-web/product-components/src/utils/digital-data-types'
import type { GenericAvailabilityType } from '@dustin-web/product-components/src/cards'
import { Icon } from '@dustin-web/microsite-components/src/icon-library'
import ProductOutOfStock from './cart-item-out-of-stock'

type Availability = GenericAvailabilityType & { isAvailableForSale: boolean }

type Props = {
  availability: Availability | null | undefined
  comment: string | null
  cartItem: CartItemFragment
  disableEditing?: boolean
  digitalDataOrigin: DigitalDataOrigin
  digitalDataIndex: number
  removeCartItem: () => void
}
export const FavoritesCartItemUtilityRow = ({
  availability,
  comment,
  cartItem,
  disableEditing = false,
  digitalDataOrigin,
  digitalDataIndex,
  removeCartItem,
}: Props) => {
  const { translate } = useI18n()
  const isAvailableForSale = availability?.isAvailableForSale || cartItem.isMandatory

  const showAddComment = !cartItem.mainProductErpIdentifier

  return (
    <div className="c-shoppingcart__utility-row-favorites d-print-none">
      {isAvailableForSale && (
        <div className="flex-shrink-0 order-md-2 align-self-start">
          {cartItem.product && isAvailableForSale && (
            <AddToCartButton
              product={cartItem.product}
              quantity={cartItem.quantity}
              isAd={false}
              mainProductErpIdentifier={cartItem.mainProductErpIdentifier || null}
              ticket={''}
              comment={comment}
              digitalDataOrigin={digitalDataOrigin}
              digitalDataIndex={digitalDataIndex}
            />
          )}
        </div>
      )}

      <div className="c-shoppingcart__utility-row-favorites--direction">
        {isAvailableForSale ? (
          <>
            {showAddComment && (
              <>
                <div>
                  <AddNote
                    comment={comment}
                    cartItemId={cartItem.id}
                    inFavorites={true}
                    disableEditing={disableEditing}
                  />
                </div>

                {!cartItem.isMandatory && (
                  <div>
                    <button
                      className="button-stripped u-mb-0 u-mr-0 u-fs-12 u-decoration-none"
                      onClick={() => removeCartItem()}>
                      <Icon name="trash-bin" className="u-mr-4 i-16" />
                      <span>{translate('Header_Remove')}</span>
                    </button>
                  </div>
                )}
              </>
            )}
          </>
        ) : (
          <ProductOutOfStock
            productErpIdentifier={cartItem.productErpIdentifier}
            productNameSlug={cartItem.product?.nameSlug}
          />
        )}
      </div>

      {!isAvailableForSale && !cartItem.isMandatory && !disableEditing && (
        <button
          className="button-stripped u-mb-0 u-mr-0 u-fs-12 u-decoration-none"
          onClick={() => removeCartItem()}>
          <Icon name="trash-bin" className="u-mr-4 i-16" />
          <span>{translate('Header_Remove')}</span>
        </button>
      )}
    </div>
  )
}

export default FavoritesCartItemUtilityRow
